import * as ko from "knockout";

import { activatePliButtonTextBinding } from "./pliButtonText";
import { activatePliDisableButtonBinding } from "./pliDisableButton";
import { activatePliDisableFieldBinding } from "./pliDisableField";
import { activatePliEnableButtonBinding } from "./pliEnableButton";
import { activatePliEnableFieldBinding } from "./pliEnableField";
import { activatePliHasFocusBinding } from "./pliHasFocus";
import { activatePliReadOnlyFieldBinding } from "./pliReadOnlyField";
import { activateStopBinding } from "./stopBinding";


export function activateAllPliBindings(): { [bindingName: string]: ko.BindingHandler } {
    return {
        pliButtonText: activatePliButtonTextBinding(),
        pliDisableButton: activatePliDisableButtonBinding(),
        pliDisableField: activatePliDisableFieldBinding(),
        pliButtonTextpliEnableButton: activatePliEnableButtonBinding(),
        pliEnableField: activatePliEnableFieldBinding(),
        pliHasFocus: activatePliHasFocusBinding(),
        pliReadOnlyField: activatePliReadOnlyFieldBinding(),
        stopBinding: activateStopBinding()
    };
}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/knockout/pliBindings.ts